import z from 'zod';

export const filtersSchema = z.object({
  location: z.object({
    state: z.string(),
    city: z.string(),
  }),
  hub: z.string(),
  period: z.string(),
});

export type FiltersFormData = z.infer<typeof filtersSchema>;
